import { Dialog, DialogTitle, DialogContent, /* DialogContentText , FormControl, InputLabel,*/ Select, MenuItem, /* FormControlLabel, Switch, */ DialogActions, Button, Grid, Input, Link, IconButton } from "@material-ui/core";
import * as React from 'react';
import { Operators } from '../../constants/data';
import { ApplicationMain } from 'src/styles/common';
import CloseIcon from '@material-ui/icons/Close';

export default class QuestionValidationComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            allData: {},
            question: {},
            showDialog: false,
            fullWidth: true,
            maxWidth: 'sm',
            iterations: [],
            validationError: false
        }
        this.handleClose = this.handleClose.bind(this);
        this.handleRemoveCriteria = this.handleRemoveCriteria.bind(this);
        this.handleControlChange = this.handleControlChange.bind(this);
        this.handleResetAll = this.handleResetAll.bind(this);
    }
    componentDidMount() {
        this.setState({
            showDialog: this.props.showDialog,
            allData: this.props.allData,
            question: this.props.question
        }, () => this.parseObjectToDynamicState());
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            showDialog: nextProps.showDialog,
            allData: nextProps.allData,
            question: nextProps.question
        });

    }
    handleClose() {
        this.props.onClose(true);
    }
    handleControlChange = (e: any) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleValidationApply = () => {
        const validations = this.parseDynamicStateToObject();
        let error: any = false;
        this.state.iterations.map((iterator: any) => {
            const questionId = 'message_' + iterator;
            const operatorName = 'operator_' + iterator;
            const valueName = 'value_' + iterator;
            if (!error && this.state[questionId] && this.state[operatorName] && this.state[valueName]) {
                error = false
            }
            else {
                error = true
            }
        })
        if (!error) {
            this.props.updateModule({
                data: {
                    pageNumber: this.props.pageNumber,
                    clusterIndex: this.props.clusterIndex,
                    questionIndex: this.props.questionIndex,
                    value: validations

                },
                field: 'validations'
            });
            this.handleClose();
        }
        this.setState({ validationError: error })

    }
    handleResetAll = () => {
        const iterations = this.state.iterations;
        const currentIterations = iterations.length;
        const question = this.state.question;
        question.validations.length = 0;
        iterations.length = 1;
        this.setState({ iterations, question }, () => this.deleteAllCriteria(currentIterations));
    }

    deleteAllCriteria = (iterations: number) => {
        for (let index = 1; index <= iterations; index++) {
            this.removeState(index);
        }
    }

    handleAddMoreCriteria = () => {
        this.setState({ iterations: [...this.state.iterations, this.state.iterations.length + 1] });
    }

    handleRemoveCriteria = (iterator: any) => {
        const iterations = this.state.iterations.filter((i: any) => i !== iterator);
        this.setState({ iterations }, () => this.removeState(iterator));

    }

    removeState = (iterator: any) => {
        const questionId = 'message_' + iterator;
        const operatorName = 'operator_' + iterator;
        const valueName = 'value_' + iterator;

        const newState: any = this.state;
        delete newState[questionId];
        delete newState[operatorName];
        delete newState[valueName];
        this.setState({ newState });
    }

    parseDynamicStateToObject = () => {
        const validations = [];
        for (let index = 1; index <= this.state.iterations.length; index++) {
            const validation = {
                operator: this.state['operator_' + index],
                value: this.state['value_' + index],
                message: {
                    en: this.state['message_' + index]
                }
            }
            validations.push(validation);
        }
        return validations;
    }
    parseObjectToDynamicState = () => {
        const iterators = this.state.iterations;
        if (this.state.question && this.state.question.validations.length > 0) {
            for (let index = 1; index <= this.state.question.validations.length; index++) {
                iterators.push(index);
                this.setState({
                    ['message_' + index]: this.state.question.validations[index - 1] ? this.state.question.validations[index - 1].message.en : '',
                    ['value_' + index]: this.state.question.validations[index - 1] ? this.state.question.validations[index - 1].value : '',
                    ['operator_' + index]: this.state.question.validations[index - 1] ? this.state.question.validations[index - 1].operator : ''
                })
            }
            this.setState({ iterations: iterators });
        }
        else {
            iterators.push(1);
            this.setState({ iterations: iterators });
        }
    }
    render() {
        return (
            <ApplicationMain>
                <Dialog
                    fullWidth={this.state.fullWidth}
                    hideBackdrop={true}
                    maxWidth={this.state.maxWidth}
                    open={this.props.showDialog}
                    aria-labelledby="max-width-dialog-title"
                    className="applicationDialog"
                >

                    <div className="dialogWrapper">
                        <div className="dialogHead">
                            <DialogTitle id="max-width-dialog-title" className="dialogTitle">Data Validation

                                 <IconButton aria-label="Close" className="closeButton" onClick={this.handleClose}>
                                    <CloseIcon />
                                </IconButton>

                                <hr className="HZDivider" />
                            </DialogTitle>
                        </div>

                        <div className="dialogContent">
                            {
                                this.state.iterations && this.state.iterations.length > 0 && (this.state.iterations.map((iterator: any) => {
                                    const oname = 'operator_' + iterator;
                                    const valueName = 'value_' + iterator;
                                    const messageName = 'message_' + iterator;

                                    return (
                                        <>
                                            <DialogContent key={iterator}>

                                                <Grid container={true} spacing={8}>
                                                    <Grid item={true} xs={12}>
                                                        <div className="dialogBox">

                                                            <Grid container={true} spacing={8}>
                                                                <Grid item={true} xs={3}>
                                                                    <label className="dialogLabel"> Operator</label>
                                                                </Grid>
                                                                <Grid item={true} xs={8}>
                                                                    <Select
                                                                        name={oname}
                                                                        fullWidth={true}
                                                                        value={this.state[oname] ? this.state[oname] : ''}
                                                                        onChange={this.handleControlChange}
                                                                    >
                                                                        {Operators.map((operator: any) => (
                                                                            <MenuItem key={'operator_' + operator.value} value={operator.value}>
                                                                                {operator.text}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </Grid>
                                                            </Grid>

                                                            <Grid container={true} spacing={8}>
                                                                <Grid item={true} xs={3}>
                                                                    <label className="dialogLabel"> Value</label>
                                                                </Grid>
                                                                <Grid item={true} xs={8}>
                                                                    <Input name={valueName} fullWidth={true} value={this.state[valueName] ? this.state[valueName] : ''}
                                                                        onChange={this.handleControlChange}
                                                                    />
                                                                </Grid>
                                                            </Grid>

                                                            <Grid container={true} spacing={8}>
                                                                <Grid item={true} xs={3}>
                                                                    <label className="dialogLabel"> Message</label>
                                                                </Grid>
                                                                <Grid item={true} xs={8}>
                                                                    <Input name={messageName} multiline={true} fullWidth={true}
                                                                        value={this.state[messageName] ? this.state[messageName] : ''}
                                                                        onChange={this.handleControlChange}

                                                                    />
                                                                </Grid>
                                                            </Grid>

                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                {iterator !== 1 && (
                                                    <Link onClick={this.handleRemoveCriteria.bind(this, iterator)} href="javascript:void(0)">- Remove Criteria</Link>
                                                )}
                                                <hr className="HZDivider" />

                                            </DialogContent>
                                        </>
                                    )
                                })
                                )
                            }
                        </div>

                        <div className="dialogAction">
                            <Grid container={true}>
                                <Grid item={true} xs={3}>
                                    <Link onClick={this.handleAddMoreCriteria} href="javascript:void(0)">+ Add more criteria</Link>
                                </Grid>
                                <Grid item={true} xs={3}>
                                    <div className="text-right">
                                        <Link className="pull-right" onClick={this.handleResetAll} href="javascript:void(0)">Reset All</Link>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container={true}>
                                <Grid item={true}>
                                    {
                                        this.state.validationError ?
                                            <p className="errorMessage"> All fields are mandatory</p> :
                                            ''
                                    }
                                </Grid>
                            </Grid>
                            <DialogActions>
                                <Button color="primary" className="btn-blue-primary" onClick={this.handleValidationApply}>
                                    Apply Criteria &nbsp; >
                                </Button>
                            </DialogActions>
                        </div>
                    </div>

                </Dialog>
            </ApplicationMain>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/questions/QuestionValidationComponent.tsx